import { isYoutubeNoCookieUrl, makeYouTubeNoCookieUrl } from "@/js/utils/youtubeUrlUtils";
import { SelectedResource, ResourceType } from "../FocusResourcePicker/SelectedFocusResources";

export function containsYoutubeNoCookie(selectedResources: SelectedResource[]): boolean {
	return selectedResources.some((x) => x.resourceType === ResourceType.Url && isYoutubeNoCookieUrl(x.resourceValue));
}

export function makeYoutubeNoCookieResource(resource: SelectedResource): SelectedResource {
	return {
		...resource,
		resourceValue: makeYouTubeNoCookieUrl(resource.resourceValue),
		resourceType: ResourceType.Url,
		isLockedFocusCompatible: true,
		openTab: false,
		hidden: true,
	};
}

/**
 * Removes YouTube No Cookie resources that are associated with a YouTube embed URL.
 * A YouTube No Cookie resource is considered associated with a YouTube embed URL if the hidden flag is set.
 */
export function removeYoutubeNoCookieResource(selectedResources: SelectedResource[]): void {
	const found: Array<{ index: number; resource: SelectedResource }> = [];
	for (let i = 0; i < selectedResources.length; i++) {
		const x = selectedResources[i];
		if (isYoutubeNoCookieUrl(x.resourceValue) && x.hidden) {
			found.push({ index: i, resource: selectedResources[i] });
		}
	}

	if (found.length > 1) {
		console.warn("Found multiple YouTube No Cookie resources that are hidden, expected only one to remove. Will remove all found items.", {
			found,
			selectedResources,
		});
	}

	for (let i = found.length - 1; i >= 0; i--) {
		selectedResources.splice(found[i].index, 1);
	}
}
